import { __decorate } from "tslib";
// import { HappyScroll } from "vue-happy-scroll";
import { Component, Vue, Prop } from "vue-property-decorator";
// import "vue-happy-scroll/docs/happy-scroll.css";
let DivScroll = class DivScroll extends Vue {
    constructor() {
        super(...arguments);
        this.scroll = {};
        // mounted() {}
    }
};
__decorate([
    Prop({ default: "" })
], DivScroll.prototype, "contentClass", void 0);
DivScroll = __decorate([
    Component({
        components: {
        // "happy-scroll": HappyScroll
        },
    })
], DivScroll);
export default DivScroll;
